import FormModel from './formModel';

const {
    formField: {
        email,
        telefono,
        apellido,
        nombre,
        codigosLocalidad,
        dni,
        fechaNacimiento,
        cargaFamilia,
        condicionLaboral,
        numeroHijos,
        montoBruto
    }
} = FormModel;


export default {
    [nombre.name]: '',
    [apellido.name]: '',
    [telefono.name]: '',
    [codigosLocalidad.name]: '',
    [fechaNacimiento.name]: '',
    [cargaFamilia.name]: '0',
    [condicionLaboral.name]: '0',
    [montoBruto.name]: 0,
    [numeroHijos.name]: '0',
    [email.name]: '',
    [dni.name]: '',
    archivos: []
};
